import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => ({
	root: {
		width: "462px",
		height: "126px",
		borderRadius: "8px",
		border: `dashed 1px ${theme.palette.grey["400"]}`,
		marginTop: "10px",
		padding: "0px 20px",
	},
	progressBar: {
		width: "260px",
		height: "4px",
		margin: "0 0 4px",
		padding: "0 180px 0 0",
		backgroundColor: theme.palette.blueGrey.main,
	},
	disabled: {
		pointerEvents: "none",
		opacity: "0.5",
	},
	EditorUploadClass: {
		height: "126px",
		width: "300px",
		marginTop: "0px",
		border: "dashed 1px " + theme.palette.grey["500"],
	},
	cautionLabel: {
		color: theme.palette.grey["500"],
	},
});
export default styles;
